/**
 * Class representing an external route.
 *
 * @example
 * // Using with <a> tag
 * <a :href="ExternalRoute.build('/privacy-policy').url">Privacy Policy</a>
 */
export default class ExternalRoute {

    /**
     * Creates an instance of ExternalRoute.
     *
     * @param {string} url
     */
    constructor(url) {
        this.url = url;
    }

    /**
     * Builds a new ExternalRoute instance.
     *
     * @param {string} url
     * @returns {ExternalRoute}
     */
    static build(url) {
        return new this(url);
    }
}
